const noop = () => {}

export function silenceDebugConsoleInProd(isProd: boolean = import.meta.env.PROD): void {
  if (!isProd) return

  console.log = noop
  console.warn = noop
  console.info = noop
  console.debug = noop
}
